import { styled } from 'baseui/src';
const TableOuterContainer = styled('div', ({
  $theme
}) => ({
  width: '100%',
  paddingTop: $theme.sizing.scale600,
  paddingBottom: $theme.sizing.scale600,
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 70px - 60px)' // subtract header and footer height
}));
const TableInnerContainer = styled('div', ({
  $theme
}) => ({
  height: '100%',
  overflow: 'auto',
  paddingTop: $theme.sizing.scale600,
  paddingBottom: $theme.sizing.scale600,
  flex: 1
}));
export { TableInnerContainer, TableOuterContainer };